module.exports = __webpack_public_path__ + "img/choose-up-cadou-disabled.7fe7bbf8.png";